import { FunctionComponent } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastProvider } from "src/context/ToastContext";
import NEATTRoutes from "./NEATTRoutes";
import ConsultantRoutes from "./ConstultantRoutes";
import SideNavigation from "src/components/navigation/SideNav";
import Account from "src/pages/dashboard/account";
import ReferralPartners from "src/pages/dashboard/ReferralPartners";
import Consultants from "src/pages/dashboard/Constultants";
import Members from "src/pages/dashboard/Members";
import AdminRoutes from "./AdminRoutes";

const DashboardRoutes: FunctionComponent = () => (
  <section className="flex">
    <ToastProvider>
      <SideNavigation />
      <Routes>
        <Route path="/" element={<></>} />

        <Route path="/account" element={<Account />} />
        <Route path="/referral-partners" element={<ReferralPartners />} />
        <Route path="/members" element={<Members />} />
        <Route path="/consultants" element={<Consultants />} />
        <Route path="/consultant/*" element={<ConsultantRoutes />} />
        <Route path="/neatt/*" element={<NEATTRoutes />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
      </Routes>
    </ToastProvider>
  </section>
);

export default DashboardRoutes;
